(function() {
  'use strict';

  // Guard: prevent double-init when script is included by multiple sections
  if (window._tableFavoritesInitialized) return;
  window._tableFavoritesInitialized = true;

  var WEBHOOK_URL = 'https://hook.eu1.make.com/xu8jtp3x3r46f6zriq5w7jrq14ww6ppx';

  // Use capture phase so the handler fires BEFORE the td's inline
  // onclick="event.stopPropagation()" which blocks bubble-phase listeners.
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.btn-fav-table');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleToggle(btn);
  }, true);

  async function handleToggle(btn) {
    if (btn.dataset.customerLoggedIn !== 'true') {
      window.location.href = '/account/login';
      return;
    }

    var productId = btn.dataset.productId;
    var customerId = btn.dataset.customerId;
    var cell = btn.closest('.fav-cell');
    var row = btn.closest('tr');
    var isFav = cell.dataset.isFav === 'true';
    var favIdsCsv = btn.dataset.favIds || '';
    var favArray = favIdsCsv ? favIdsCsv.split(',').filter(Boolean) : [];

    // Toggle array
    if (isFav) {
      favArray = favArray.filter(function(id) { return id !== productId; });
    } else {
      if (favArray.indexOf(productId) === -1) favArray.push(productId);
    }
    var newIsFav = !isFav;

    // Optimistic UI
    btn.disabled = true;
    cell.dataset.isFav = newIsFav.toString();
    btn.querySelector('.fav-icon').innerHTML = newIsFav ? '&#9733;' : '&#9734;';
    updateAllStarsForProduct(productId, newIsFav, favArray);

    // If unfavoriting from the favorites table, animate row removal
    var favoritesTable = row ? row.closest('#favoritesTable') : null;
    if (favoritesTable && !newIsFav && row) {
      row.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      row.style.opacity = '0.4';
      row.style.transform = 'translateX(10px)';
    }

    try {
      var productGids = favArray.map(function(id) { return 'gid://shopify/Product/' + id; });
      var shopifyBody = JSON.stringify({
        metafield: { namespace: 'custom', key: 'fav_tickers', type: 'list.product_reference', value: JSON.stringify(productGids) }
      });
      var response = await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: String(customerId), shopify_body: shopifyBody })
      });
      if (!response.ok) throw new Error('HTTP error: ' + response.status);

      // Remove row from favorites table after successful webhook
      if (favoritesTable && !newIsFav && row) {
        setTimeout(function() {
          row.remove();
          updateFavoritesCounter(favoritesTable, favArray.length);
        }, 350);
      }
    } catch (error) {
      console.error('Error saving favorite:', error);
      // Revert
      cell.dataset.isFav = isFav.toString();
      btn.querySelector('.fav-icon').innerHTML = isFav ? '&#9733;' : '&#9734;';
      var revertArray = favIdsCsv ? favIdsCsv.split(',').filter(Boolean) : [];
      updateAllStarsForProduct(productId, isFav, revertArray);
      // Revert row animation
      if (favoritesTable && row) {
        row.style.opacity = '1';
        row.style.transform = 'none';
      }
    } finally {
      btn.disabled = false;
    }
  }

  // Update the favorites counter after row removal
  function updateFavoritesCounter(table, newCount) {
    var section = table.closest('.customer-favorites');
    if (!section) return;
    var counter = section.querySelector('.customer-profile__section-counter');
    if (counter) {
      if (newCount > 0) {
        counter.textContent = newCount + ' ' + (counter.textContent.replace(/\d+\s*/, '').trim() || 'empresas');
      } else {
        counter.style.display = 'none';
      }
    }
    // Show empty state if no favorites left
    if (newCount === 0) {
      var tableWrapper = table.closest('.product-table');
      var noteEl = section.querySelector('.favorites-note');
      if (tableWrapper) tableWrapper.style.display = 'none';
      if (noteEl) noteEl.style.display = 'none';
      var emptyState = section.querySelector('.favorites-empty');
      if (emptyState) {
        emptyState.style.display = '';
      }
    }
  }

  // Sync ALL stars for the same product on the page
  function updateAllStarsForProduct(productId, isFav, favArray) {
    var newCsv = favArray.join(',');
    // Update buttons for this product
    document.querySelectorAll('.btn-fav-table[data-product-id="' + productId + '"]').forEach(function(b) {
      var c = b.closest('.fav-cell');
      if (c) c.dataset.isFav = isFav.toString();
      b.querySelector('.fav-icon').innerHTML = isFav ? '&#9733;' : '&#9734;';
    });
    // Update fav-ids on ALL buttons to keep the list in sync
    document.querySelectorAll('.btn-fav-table').forEach(function(b) {
      b.dataset.favIds = newCsv;
    });
  }
})();
